import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGeneralContext } from '../../GeneralContext.js';
import { STORAGE_KEYS } from '../../../constants.js';
import { defaultCharacter } from './characterDefaults.js';

export const useCharacterPersistence = (index, character, setCharacter) => {
  const navigate = useNavigate();
  const { charIndex, updateCharIndex, deleteCharacter } = useGeneralContext();
  const [loaded, setLoaded] = useState(false);
  const [originalName, setOriginalName] = useState();

  const loadCharacter = useCallback(
    () => {
      const saved = localStorage.getItem(index);
      if (saved) {
        const char = { ...defaultCharacter, ...JSON.parse(saved) };
        setCharacter(char);
        setOriginalName(char.name);
      } else {
        setCharacter({ ...defaultCharacter });
        setOriginalName();
      }
      setLoaded(true);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [index]
  );

  const saveCharacter = () => {
    if (!character.name) return;

    var idx = charIndex;
    const name = `${STORAGE_KEYS.CHARACTER_PREFIX}${character.name}`;

    if (character.name !== originalName) {
      idx = deleteCharacter(originalName);
      setOriginalName(character.name);
    }
    if (!idx.includes(name)) {
      const updated = [...idx, name];
      localStorage.setItem(
        STORAGE_KEYS.CHARACTER_INDEXES,
        JSON.stringify(updated)
      );
      updateCharIndex(updated);
      navigate('/' + name);
    }
    character.previousSave = true;
    character.unsavedChanges = false;
    localStorage.setItem(name, JSON.stringify(character));
  };

  return { loaded, loadCharacter, saveCharacter };
};
